<template>
  <!-- 投诉工单详情展示 -->
  <a-modal
    :title="formTitle || '投诉工单详情'"
    v-model:visible="open"
    @cancel="onClose"
    :width="800"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="detail-form-modal"
  >
    <!-- 表单内容 -->
    <a-form
      :model="form"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
      class="two-column-form"
    >
      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 类型 -->
          <a-form-item label="类型">
            <a-input
              :value="getTypeLabel(form.type)"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 状态 -->
          <a-form-item label="状态">
            <a-input
              :value="getStatusLabel(form.complaintStatus)"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 发起源 -->
          <a-form-item label="发起源">
            <a-input
              :value="getFromTypeLabel(form.fromType)"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 发起人 -->
          <a-form-item label="发起人">
            <a-input
              :value="form.userName || '-'"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 问题描述 -->
          <a-form-item label="问题描述">
            <a-input
              :value="form.description || '-'"
              disabled
              type="textarea"
              :rows="3"
              placeholder="-"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 手机号 -->
          <a-form-item label="手机号">
            <a-input
              :value="form.phone || '-'"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 所在空间 -->
          <a-form-item label="所在空间">
            <a-input
              :value="form.spaceName || '-'"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 空间负责员工 -->
          <a-form-item label="空间负责员工">
            <a-input
              :value="form.employeeName || '-'"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 空间主管 -->
          <a-form-item label="空间主管">
            <a-input
              :value="form.supervisorName || '-'"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 响应员工 -->
          <a-form-item label="响应员工">
            <a-input
              :value="form.responseName || '-'"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 响应时间 -->
          <a-form-item label="响应时间">
            <a-input
              :value="parseTime(form.responseTime) || '-'"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 确认员工 -->
          <a-form-item label="确认员工">
            <a-input
              :value="form.confirmName || '-'"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 确认时间 -->
          <a-form-item label="确认时间">
            <a-input
              :value="parseTime(form.confirmTime) || '-'"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 关闭员工 -->
          <a-form-item label="关闭员工">
            <a-input
              :value="form.closingName || '-'"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 关闭时间 -->
          <a-form-item label="关闭时间">
            <a-input
              :value="parseTime(form.closingTime) || '-'"
              disabled
              placeholder="-"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="24">
          <!-- 照片 -->
          <a-form-item label="照片">
            <file-upload
              :value="form.url || ''"
              type="image"
              :count="9"
              field-name="url"
              :disabled="true"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 操作按钮 -->
      <div class="bottom-control">
        <a-space>
          <a-button @click="onClose" class="cancel-btn"> 关闭 </a-button>
        </a-space>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
/**
 * 投诉工单详情展示组件
 * - 只读展示，包含所有详情字段
 * - 类型、发起源使用字典标签显示
 * - 照片使用图片上传组件展示
 * - 时间字段格式化显示
 */
import { getComplaintOrder } from '@/api/system/complaintOrder'
import { parseTime } from '@/utils/ruoyi'

export default {
  name: 'FormDetail',
  dicts: ['originator', 'complaint_type', 'complaint_status'],
  props: {},
  components: {},
  data() {
    return {
      formTitle: '投诉工单详情',
      open: false,
      form: {
        id: null,
        type: null,
        fromType: null,
        userName: null,
        complaintStatus: null,
        description: null,
        phone: null,
        spaceName: null,
        url: null,
        employeeName: null,
        supervisorName: null,
        responseName: null,
        responseTime: null,
        confirmName: null,
        confirmTime: null,
        closingName: null,
        closingTime: null,
      },
    }
  },
  computed: {},
  methods: {
    /**
     * 关闭弹窗
     */
    onClose() {
      this.open = false
    },
    /**
     * 打开详情弹窗
     * @param {Object} row - 行数据对象
     * @param {Number|String} ids - 工单ID（当row为空时使用）
     */
    handleUpdate(row, ids) {
      const id = row ? row.id : ids
      if (!id) {
        this.$message.warning('工单ID不能为空', 3)
        return
      }
      // 重置表单
      this.form = {
        id: null,
        type: null,
        fromType: null,
        userName: null,
        description: null,
        phone: null,
        spaceName: null,
        url: null,
        employeeName: null,
        supervisorName: null,
        responseName: null,
        responseTime: null,
        confirmName: null,
        confirmTime: null,
        closingName: null,
        closingTime: null,
        complaintStatus: null,
      }
      // 获取详情
      getComplaintOrder({ id: id })
        .then((response) => {
          if (response && response.data) {
            this.form = response.data
            this.open = true
          } else {
            this.$message.error('获取工单详情失败', 3)
          }
        })
        .catch(() => {
          this.$message.error('获取工单详情失败，请稍后重试', 3)
        })
    },
    /**
     * 时间格式化（复用工具函数）
     * @param {String|Date} time - 时间
     * @returns {String} 格式化后的时间字符串
     */
    parseTime(time) {
      return parseTime(time)
    },
    /**
     * 获取类型标签
     * @param {String|Number} value - 类型值
     * @returns {String} 类型标签
     */
    getTypeLabel(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      const typeDict = this.dict?.type?.['complaint_type'] || []
      const target = typeDict.find((item) => item.value == value)
      return target ? target.label : value
    },
    /**
     * 获取状态标签
     * @param {String|Number} value - 状态值
     * @returns {String} 状态标签
     */
    getStatusLabel(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      const statusDict = this.dict?.type?.['complaint_status'] || []
      const target = statusDict.find((item) => item.value == value)
      return target ? target.label : value
    },
    /**
     * 获取发起源标签
     * @param {String|Number} value - 发起源值
     * @returns {String} 发起源标签
     */
    getFromTypeLabel(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      const fromTypeDict = this.dict?.type?.['originator'] || []
      const target = fromTypeDict.find((item) => item.value == value)
      return target ? target.label : value
    },
  },
}
</script>

<style scoped>
.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 0;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.detail-form-modal .ant-modal-body {
  padding: 20px 16px 44px 4px !important;
}

/* 表单左边距调整 - 使用全局样式 */
.detail-form-modal .ant-form {
  margin-left: -24px !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

/* 输入框样式 - 圆角和边框 */
.detail-form-modal .ant-input,
.detail-form-modal .ant-input:hover,
.detail-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
  background-color: #f5f5f5 !important;
}

.detail-form-modal .ant-input-affix-wrapper,
.detail-form-modal .ant-input-affix-wrapper:hover,
.detail-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
  background-color: #f5f5f5 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.detail-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.detail-form-modal .ant-select-selector,
.detail-form-modal .ant-select-selector:hover,
.detail-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
  background-color: #f5f5f5 !important;
}

/* 日期选择器样式 */
.detail-form-modal .ant-picker,
.detail-form-modal .ant-picker:hover,
.detail-form-modal .ant-picker-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
  background-color: #f5f5f5 !important;
}

/* 数字输入框样式 */
.detail-form-modal .ant-input-number,
.detail-form-modal .ant-input-number:hover,
.detail-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
  background-color: #f5f5f5 !important;
}

/* 按钮保持圆角 */
.detail-form-modal .ant-btn {
  border-radius: 4px !important;
}

/* 两列布局样式 */
.two-column-form :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.two-column-form :deep(.ant-row) {
  flex-wrap: nowrap;
}

.two-column-form :deep(.ant-col-12) {
  width: 50%;
  max-width: 50%;
}

/* 减少列之间的间距 */
.two-column-form :deep(.ant-col-12:first-child) {
  padding-right: 6px !important;
}

.two-column-form :deep(.ant-col-12:last-child) {
  padding-left: 6px !important;
}

/* 减少整个表单的左边距 */
.two-column-form :deep(.ant-form-item) {
  margin-left: -8px !important;
  margin-right: -8px !important;
}

/* 调整标签对齐，确保不会过于靠右 */
.two-column-form :deep(.ant-form-item-label) {
  margin-right: -4px !important;
}
</style>
